function CubePainter() {
  return (
    <div class="cube">
      <iframe title="CUBE" src="3d_Engine.html" width="100%" height="100%"/>

    </div>
  );
}

export default CubePainter;